import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { createRoot } from 'react-dom/client';
import React from 'react';

import App from './components/App';
import configureStore from './store/configureStore';

import './styles/main.scss';

export const store = configureStore();
const root = createRoot(document.getElementById('root'));

root.render(<App store={store} />);

const metaHot = import.meta.hot;

if (metaHot && process.env.NODE_ENV !== 'production') {
    metaHot.accept('./components/App', () => {
        root.render(<App store={store} />);
    });
}
